import React from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_boostpro-demo/artifacts/nqty693k_boostpro-logo-transparent.svg";

export const Footer = () => {
  return (
    <footer data-testid="site-footer" className="relative border-t border-white/5 bg-[#060B14]">
      <div className="absolute inset-0 bg-grid opacity-30 pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 md:px-10 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <Link to="/" className="flex items-center gap-3">
              <div className="h-11 w-11 rounded-xl overflow-hidden ring-1 ring-white/10">
                <img src={LOGO_URL} alt="BoostPro" className="h-full w-full object-cover" />
              </div>
              <div>
                <div className="font-display font-bold text-white text-lg">BoostPro</div>
                <div className="text-[10px] uppercase tracking-[0.2em] text-blue-400/80">Pilotez votre activité</div>
              </div>
            </Link>
            <p className="mt-5 text-sm leading-relaxed text-slate-400 max-w-md">
              L'application mobile pensée pour les indépendants, artisans et petites entreprises.
              Clients, factures, dépenses et rentabilité, dans votre poche.
            </p>
            <a
              href="mailto:boostpro.app@gmail.com"
              data-testid="footer-email"
              className="inline-flex items-center gap-2 mt-5 text-sm text-slate-300 hover:text-white transition-colors"
            >
              <Mail size={16} className="text-blue-400" />
              boostpro.app@gmail.com
            </a>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">Navigation</h4>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-home" to="/" className="text-slate-400 hover:text-white transition-colors">Accueil</Link></li>
              <li><Link data-testid="footer-link-features" to="/fonctionnalites" className="text-slate-400 hover:text-white transition-colors">Fonctionnalités</Link></li>
              <li><Link data-testid="footer-link-contact" to="/contact" className="text-slate-400 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.2em] text-blue-400 mb-4">Légal</h4>
            <ul className="space-y-3 text-sm">
              <li><Link data-testid="footer-link-privacy" to="/privacy" className="text-slate-400 hover:text-white transition-colors">Politique de confidentialité</Link></li>
              <li><Link data-testid="footer-link-terms" to="/terms" className="text-slate-400 hover:text-white transition-colors">Conditions d'utilisation</Link></li>
            </ul>
          </div>
        </div>

        <div className="mt-14 pt-6 border-t border-white/5 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="text-xs text-slate-500">© {new Date().getFullYear()} BoostPro. Tous droits réservés.</p>
          <p className="text-xs text-slate-500">Conçu pour les indépendants, en France.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
